module.exports = __webpack_public_path__ + "fonts/TT-Norms_Bold.7743dd8.woff";